import { InputLabel } from "@mui/material";
import React from "react";
import './customInputLabel.css'
import { isUndefined } from "../../utils/utils";

const CustomInputLabel = ({label, customClassName}) => {
  return <InputLabel className={!isUndefined(customClassName) ?customClassName :"custom-input-label"} >{label}</InputLabel>
}

export default CustomInputLabel